module.exports = __webpack_public_path__ + "static/media/vibino-feature-Add text-pic3.bc6928d7.jpg";